import React from "react";
import { useIntl } from "react-intl";
import Select, { components } from "react-select";

const customStyles = [
  {
    component: "container",
    style: { height: "2.6rem", margin: "0 0.3125rem" },
  },
  { component: "placeholder", style: { opacity: "0.5" } },
  { component: "menu", style: { marginTop: 0, top: "auto" } },
  { component: "menuList", style: { paddingTop: 0, textAlign: "left" } },
].reduce((acc, { component, style }) => {
  acc[component] = (provided) => ({ ...provided, ...style });
  return acc;
}, {});

const headerStyle = {
  padding: "0.5rem 0.75rem",
  backgroundColor: "#004594",
  color: "white",
};

const MenuList = (props) => {
  const headerText = useIntl().formatMessage({ id: "pleaseSelect" });
  return (
    <components.MenuList {...props}>
      <div className="simpleSelect__header" style={headerStyle}>
        {headerText}
      </div>
      {props.children}
    </components.MenuList>
  );
};

export default (props) => (
  <Select
    components={{ MenuList }}
    className="simpleSelect"
    classNamePrefix="simpleSelect"
    placeholder={useIntl().formatMessage({ id: "pleaseSelect" })}
    styles={customStyles}
    {...props}
  />
);
